import React, { useCallback, useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { ButtonData_Type, Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { getFullLinkUrl } from "./../../_shared/link/get-full-link-url";
import { getRelValue } from "./../../wix-rich-content-common";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/default-styles-scss";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "../types";
const ButtonViewer = ({
  onClick,
  helpers,
  settings = {},
  buttonData,
  nodeId,
  baseUrl
}) => {
  const { tabIndex } = useContext(RicosContext);
  const isActionButton = buttonData.type === ButtonData_Type.ACTION;
  const onClickHandler = useCallback(() => {
    helpers?.onViewerAction?.(
      isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE,
      "Click",
      "",
      nodeId,
      {
        type: Node_Type.BUTTON,
        buttonData
      }
    );
    onClick?.();
  }, [helpers?.onViewerAction]);
  const ButtonComponent = settings.customComponent ? settings.customComponent : isActionButton ? ActionButton : LinkButton;
  const style = {
    color: buttonData?.styles?.colors?.text ?? settings.colors?.color1,
    background: buttonData?.styles?.colors?.background ?? settings.colors?.color8,
    borderRadius: buttonData.styles?.border?.radius,
    width: `min(100%, ${buttonData.containerData?.width?.custom}px)`,
    border: `${buttonData.styles?.border?.width || 0}px solid ${buttonData?.styles?.colors?.border ?? settings.colors?.color8 ?? ""}`
  };
  return /* @__PURE__ */ React.createElement(
    ButtonComponent,
    {
      className: styles.button_container,
      style,
      "data-hook": ROOT,
      onClick: onClickHandler,
      tabIndex,
      buttonData,
      ...!isActionButton && {
        href: buttonData.link ? getFullLinkUrl(buttonData.link, baseUrl) : void 0,
        target: buttonData.link?.target && `_${buttonData.link.target.toLowerCase()}`,
        rel: buttonData.link?.rel?.nofollow ? getRelValue("nofollow") : void 0
      }
    }
  );
};
const LinkButton = (props) => {
  const { buttonData, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      ...rest,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          props.onClick?.();
        }
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text)
  );
};
const ActionButton = (props) => {
  const { buttonData, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      type: "button",
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          props.onClick?.();
        }
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text)
  );
};
export {
  ButtonViewer
};
//# sourceMappingURL=button-viewer.js.map
